import { z } from "zod";
import { gamificationActionSchema, questFilterSchema, questTypeSchema } from "./enum.js";

export const userQuestSchema = z.object({
	id: z.string(),
	quest_id: z.string(),
	code: z.string(),
	type: questTypeSchema,
	label_key: z.string(),
	description_key: z.string(),
	target_action: gamificationActionSchema,
	target: z.number().int().positive(),
	progress: z.number().int().nonnegative(),
	xp_reward: z.number().int().nonnegative(),
	cosmetic_reward_id: z.string().nullable(),
	period_key: z.string(),
	completed_at: z.number().int().positive().nullable(),
	claimed_at: z.number().int().positive().nullable(),
	created_at: z.number().int().positive(),
});

export type UserQuest = z.infer<typeof userQuestSchema>;

export const listQuestsQuerySchema = z.object({
	type: questFilterSchema.default("all"),
});

export type ListQuestsQuery = z.infer<typeof listQuestsQuerySchema>;

export const listQuestsResponseSchema = z.object({
	daily: z.array(userQuestSchema),
	weekly: z.array(userQuestSchema),
});

export type ListQuestsResponse = z.infer<typeof listQuestsResponseSchema>;

export const claimQuestResponseSchema = z.object({
	user_quest_id: z.string(),
	xp_awarded: z.number().int().nonnegative(),
	cosmetic_unlocked_id: z.string().nullable(),
	new_total_xp: z.number().int().nonnegative(),
	new_level: z.number().int().positive(),
	leveled_up: z.boolean(),
	badges_unlocked_ids: z.array(z.string()),
});

export type ClaimQuestResponse = z.infer<typeof claimQuestResponseSchema>;
